import React, { useState } from 'react'
/* import { Wheel } from 'react-custom-roulette' */
import Wheel from 'components/instant-win/instant-win-wheel/Wheel'
import star from 'images/star.svg'
import marker from 'images/marker.svg'
import './InstantWinWheel.scss'

const InstantWinWheel = ({ data=[], button, wheelConfig, handleAfterSpin }) => {

    let prizeNumber = 0
    if (wheelConfig.prizeId) {
        prizeNumber = data.findIndex((item => {
            return item.id === wheelConfig.prizeId
        }))
    }

    console.log(`prizeNumber`, prizeNumber)

    return (
        <div className="center">
            <div className="mostOuterBorder">
                <div className="marker">
                    <img src={marker} alt="" />
                </div>
                <div className="extraBorder"></div>
                <Wheel
                    mustStartSpinning={wheelConfig.shouldSpin}
                    startingOptionIndex= { 0 }
                    prizeNumber={ prizeNumber }
                    data={data}
                    backgroundColors={['#D5D8DC', '#808B96', '#EAECEE', '#FFF', '#ABB2B9']} // '#C0C0C0', '#FFFFFF', '#F5F5F5'
                    outerBorderWidth={15}
                    outerBorderColor="#EA983E"
                    innerBorderWidth={65}
                    innerBorderColor="#EA983E"
                    radiusLineWidth={0}
                    radiusLineColor="transparent"
                    textColors={['#EA983E', "#183E88", "#3B8EDE"]}
                    fontSize={26}
                    textDistance={70}
                    onStopSpinning={handleAfterSpin}
                    spinDuration={0.5}
                    perpendicularText={true}
                />
                <div className="star">
                    <img src={star} alt="" />
                </div>
            </div>
            <div className='button-container'>
            { button }
            </div>
        </div>
    )
};

export default InstantWinWheel;